import { render, staticRenderFns } from "./Clientes_Crear_Editar.vue?vue&type=template&id=c1885f8e&"
import script from "./Clientes_Crear_Editar.vue?vue&type=script&lang=js&"
export * from "./Clientes_Crear_Editar.vue?vue&type=script&lang=js&"
import style0 from "./Clientes_Crear_Editar.vue?vue&type=style&index=0&id=c1885f8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports